<div class="st-object-placeholder-create-header">
    <div class="st-object-placeholder-create__icon">
        <mat-icon fontSet="material-symbols-outlined">add_box</mat-icon>
    </div>
    <h2 class="st-object-placeholder-create__title">{{ languageSettings()?.PSTWebObjectPlaceholderCreateTitle }}</h2>
</div>

<div class="st-object-placeholder-create__field">
    <st-text-field
        #mosSlugCb
        [placeholder]="languageSettings()?.PSTWebObjectPlaceholderFieldSlug"
        [label]="languageSettings()?.PSTWebObjectPlaceholderFieldSlug"
        [value]="mosObjectPlaceholder()?.slug"
        (changed)="onSlugChanged($event)" />
</div>

<div class="st-object-placeholder-create__field">
    <st-text-field
        #mosGroupCb
        [placeholder]="languageSettings()?.PSTWebObjectPlaceholderFieldGroup"
        [label]="languageSettings()?.PSTWebObjectPlaceholderFieldGroup"
        [value]="mosObjectPlaceholder()?.group"
        (changed)="onGroupChanged($event)" />
</div>

<div class="st-object-placeholder-create__field">
    <st-combo-box
        #mosTypesCb
        [placeholder]="languageSettings()?.PSTWebObjectPlaceholderFieldType"
        [label]="languageSettings()?.PSTWebObjectPlaceholderFieldType"
        [itemList]="mosTypes()"
        (changed)="onMosTypeChanged($event)" />
</div>

<div class="st-object-placeholder-create__field">
    <st-combo-box
        #mosDevicesCb
        [placeholder]="languageSettings()?.PSTWebObjectPlaceholderFieldDevice"
        [label]="languageSettings()?.PSTWebObjectPlaceholderFieldDevice"
        [itemList]="autoCreateMosDeviceItems"
        (changed)="onDeviceChanged($event)" />
</div>

<div class="st-object-placeholder-create-footer">
    <button
        mat-button
        (click)="cancelPlaceholderCreate()">
        {{ languageSettings()?.PSTWebCancelButtonLabel }}
    </button>
    <button
        mat-flat-button
        color="primary"
        class="st-object-placeholder-create__save-btn"
        [disabled]="!canSave()"
        (click)="createPlaceholder()">
        {{ languageSettings()?.PSTWebSaveButtonLabel }}
    </button>
</div>
